export const PREF_KEY = 'playerso:currency';
export const RECENT_KEY = 'playerso:recent-currencies';
export const MAX_RECENT = 5;

/** Load the saved display currency code, or null when absent/unreadable. */
export function loadPreferredCurrency(): string | null {
  try {
    if (typeof localStorage === 'undefined') return null;
    const raw = localStorage.getItem(PREF_KEY);
    if (typeof raw !== 'string' || raw.trim() === '') return null;
    return raw;
  } catch {
    return null;
  }
}

/** Persist the display currency code. Swallows storage errors. */
export function savePreferredCurrency(code: string): void {
  try {
    if (typeof localStorage === 'undefined') return;
    localStorage.setItem(PREF_KEY, code);
  } catch {
    /* storage unavailable — preference applies for this session only */
  }
}

/** Load recently used currency codes (newest first), or [] when absent/unreadable. */
export function loadRecentCurrencies(): string[] {
  try {
    if (typeof localStorage === 'undefined') return [];
    const raw = localStorage.getItem(RECENT_KEY);
    if (!raw) return [];
    const parsed: unknown = JSON.parse(raw);
    if (!Array.isArray(parsed)) return [];
    return parsed.filter((v): v is string => typeof v === 'string' && v.trim() !== '');
  } catch {
    return [];
  }
}

/** Persist the recent list. Swallows storage errors. */
export function saveRecentCurrencies(codes: string[]): void {
  try {
    if (typeof localStorage === 'undefined') return;
    localStorage.setItem(RECENT_KEY, JSON.stringify(codes));
  } catch {
    /* storage unavailable — recents apply for this session only */
  }
}

/** Push a code to the front of the recents (deduped, capped). Returns the next list. */
export function pushRecentCurrency(code: string): string[] {
  const upper = code.toUpperCase();
  const next = [upper, ...loadRecentCurrencies().filter((c) => c.toUpperCase() !== upper)].slice(
    0,
    MAX_RECENT,
  );
  saveRecentCurrencies(next);
  return next;
}
